module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('div', {
    attrs: {
      "id": "editorjs"
    }
  }), _vm._v(" "), _c('v-row', {
    staticClass: "editor-row"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "ma-1 white--text",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading,
      "color": "blue-grey"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download\n      "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("mdi-cloud-download")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "primary",
      "width": "200"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "right": ""
    },
    on: {
      "click": _vm.cancelClick
    }
  }, [_vm._v("\n      Close\n      ")])], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "success",
      "rounded": "pill",
      "timeout": _vm.snackbarTimeout
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var snackattrs = ref.snackattrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "white",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.snackbar = false
            }
          }
        }, 'v-btn', snackattrs, false), [_vm._v("\n        Close\n      ")])]
      }
    }]),
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("     \n    " + _vm._s(_vm.snackbarText) + "\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01ff08b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/editorjs.vue
// module id = 1969
// module chunks = 0